import React from 'react';
import Loader from './loader';

// eslint-disable-next-line react/display-name
export default props => {
    return (
        <Loader showHide ={props.loadingMessage} ></Loader>
    );
};